import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const profileSettingsPageGeneralSectionK = {
  profilePicture: "profile_settings_page_general_section.profilePicture",
  units: "profile_settings_page_general_section.units",
  dateFormat: "profile_settings_page_general_section.dateFormat",
  deleteProfilePicture: "profile_settings_page_general_section.deleteProfilePicture",
  language: "profile_settings_page_general_section.language",
  editProfilePicture: "profile_settings_page_general_section.editProfilePicture",
  deleteProfilePictureConfirmation: "profile_settings_page_general_section.deleteProfilePictureConfirmation",
  customer: "profile_settings_page_general_section.customer",
};

export const useProfileSettingsPageGeneralSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      profilePicture: t(profileSettingsPageGeneralSectionK.profilePicture),
      units: t(profileSettingsPageGeneralSectionK.units),
      dateFormat: t(profileSettingsPageGeneralSectionK.dateFormat),
      deleteProfilePicture: t(profileSettingsPageGeneralSectionK.deleteProfilePicture),
      language: t(profileSettingsPageGeneralSectionK.language),
      editProfilePicture: t(profileSettingsPageGeneralSectionK.editProfilePicture),
      deleteProfilePictureConfirmation: t(profileSettingsPageGeneralSectionK.deleteProfilePictureConfirmation),
      customer: t(profileSettingsPageGeneralSectionK.customer),
    }),
    [i18n.language]
  );
};